import React, { Component } from "react";
import { formatLatestDate } from "../../../../components/formatDateAndTime/formatDateAndTime";

const avatarColors = [
    "#f44336", "#e91e63", "#9c27b0", "#673ab7",
    "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4",
    "#009688", "#4caf50", "#8bc34a", "#cddc39",
    "#ffeb3b", "#ffc107", "#ff9800", "#ff5722",
];

const getAvatarColor = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return avatarColors[Math.abs(hash) % avatarColors.length];
};

class ChatContacts extends Component {
    handleSelectUser(user_id) {
        const { selectedUser, onSelectUser } = this.props;
        if (+selectedUser === +user_id) return;
        onSelectUser(user_id);
    }

    render() {
        const { waMessageContacts = [], selectedUser } = this.props;

        return (
            <div style={{ width: "100%", borderRight: "1px solid #ddd", backgroundColor: "#fff", height: "100%" }}>
                {waMessageContacts.map((user) => {
                    const avatarColor = getAvatarColor(user.name + user.wa_contact_id);
                    const isSelected = selectedUser === user.wa_contact_id;
                    return (
                        <div
                            key={user.wa_contact_id}
                            onClick={() => this.handleSelectUser(user.wa_contact_id)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "10px 16px",
                                cursor: "pointer",
                                backgroundColor: isSelected ? "#f0f2f5" : "transparent",
                                borderBottom: "1px solid #f5f6f6",
                            }}
                            onMouseEnter={(e) => { if (!isSelected) e.currentTarget.style.backgroundColor = "#f5f6f6"; }}
                            onMouseLeave={(e) => { if (!isSelected) e.currentTarget.style.backgroundColor = "transparent"; }}
                        >
                            <div style={{ position: "relative", flexShrink: 0 }}>
                                <div style={{
                                    width: 34, height: 34, borderRadius: "50%",
                                    backgroundColor: avatarColor, color: "#fff",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    fontWeight: "bold", fontSize: 14,
                                }}>
                                    {user.name[0]}
                                </div>
                                {user.unread > 0 && (
                                    <span style={{
                                        position: "absolute", top: -4, right: -4,
                                        backgroundColor: "#25D366", color: "#fff",
                                        borderRadius: "50%", fontSize: 10, fontWeight: 700,
                                        minWidth: 18, height: 18,
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        padding: "0 4px",
                                    }}>
                                        {user.unread}
                                    </span>
                                )}
                            </div>

                            <div style={{ marginLeft: 12, flex: 1, minWidth: 0 }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{
                                        fontWeight: "bold", fontSize: 14,
                                        overflow: "hidden", textOverflow: "ellipsis",
                                        whiteSpace: "nowrap", maxWidth: "70%",
                                    }}>
                                        {user.name.length > 15 ? `${user.name.substring(0, 15)}…` : user.name}
                                    </span>
                                    <small className="text-muted" style={{ flexShrink: 0 }}>
                                        {formatLatestDate(user.last_message_time)}
                                    </small>
                                </div>
                                <div style={{
                                    overflow: "hidden", whiteSpace: "nowrap",
                                    textOverflow: "ellipsis", fontSize: 13,
                                    color: "#667781", marginTop: 2,
                                }}>
                                    {user.last_message
                                        ? (user.last_message.length > 30
                                            ? `${user.last_message.substring(0, 30)}…`
                                            : user.last_message)
                                        : (user.mobile || "")}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default ChatContacts;
